import React, {useEffect, useState} from "react";
import QSelect from "../../../../common/components/QSelect";
import SetupApi from "../../../../common/api/functions/Setup";
import {ResponseInterface} from "../../../../interfaces/ResponseInterface";
import {
    AccountInterface,
    JournalInterface,
} from "../../../../interfaces/economic/CommonInterface";
import {SelectOptionInterface} from "../../../../interfaces/SelectOptionInterface";
import {useDispatch} from "react-redux";
import {setLoading} from "../../../../app/rootReducer";
import {useTranslation} from "react-i18next";
import SetupOptionsError from "./SetupOptionsError";
import {useSeedCommonDefaults} from "../helpers/useSeedCommonDefaults";

interface Props {
    formik: any
}

const Subscription: React.FC<Props> = ({formik}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const [cashbooks, setCashbooks] = useState<JournalInterface[]>([]);
    const [accounts, setAccounts] = useState<AccountInterface[]>([]);
    const [loadError, setLoadError] = useState(false);
    const [optionsLoading, setOptionsLoading] = useState(false);
    const [reloadKey, setReloadKey] = useState(0);

    useSeedCommonDefaults(formik);

    useEffect(() => {
        let cancelled = false;
        setOptionsLoading(true);
        setLoadError(false);
        SetupApi.getDataSetupPayment().then(async (response: ResponseInterface | any) => {
            if (cancelled) return;
            let {cashbooks, accounts} = response?.data?.data || {};
            setCashbooks(cashbooks || []);
            setAccounts(accounts || []);
            dispatch(setLoading(false));
        }).catch(() => {
            if (!cancelled) {
                setLoadError(true);
                dispatch(setLoading(false));
            }
        }).finally(() => {
            if (!cancelled) setOptionsLoading(false);
        });
        return () => { cancelled = true; };
    }, [dispatch, reloadKey]);

    return (
        <React.Fragment>
            {loadError ? (
                <SetupOptionsError
                    loading={optionsLoading}
                    onRetry={() => setReloadKey((k) => k + 1)}
                />
            ) : null}
            <QSelect
                label={t("economic.cashbook")}
                value={formik.values.economic_subscription_cashbook_number}
                onChange={(option: SelectOptionInterface) => {
                    formik.setFieldValue('economic_subscription_cashbook_number', option.value);
                }}
                options={cashbooks.map((a: JournalInterface) => ({label: a.name, value: a.journalNumber}))}
                error={formik.errors?.economic_subscription_cashbook_number}
            />
            <QSelect
                label={t("economic.balanceAccount")}
                value={formik.values.economic_subscription_balance_account_number}
                onChange={(option: SelectOptionInterface) => {
                    formik.setFieldValue('economic_subscription_balance_account_number', option.value);
                }}
                options={accounts.map((a: AccountInterface) => ({
                    label: a.accountNumber + ' - ' + a.name,
                    value: a.accountNumber
                }))}
                error={formik.errors?.economic_subscription_balance_account_number}
            />
            <QSelect
                label={t("economic.salesAccount")}
                value={formik.values.economic_subscription_sales_account_number}
                onChange={(option: SelectOptionInterface) => {
                    formik.setFieldValue('economic_subscription_sales_account_number', option.value);
                }}
                options={accounts.map((a: AccountInterface) => ({
                    label: a.accountNumber + ' - ' + a.name,
                    value: a.accountNumber
                }))}
                error={formik.errors?.economic_subscription_sales_account_number}
            />
        </React.Fragment>
    )
}

export default Subscription;
